import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { AccountInfoType, ConfirmationType } from 'shared/types';
import { useAccessControl } from 'utils/access-control';
import Workflows from './screens';
import EditWorkflow from './screens/edit';

const WorkflowRoutes = (props: {
  accountInfo: AccountInfoType;
  setConfirmationData: (
    str: ConfirmationType | React.SetStateAction<ConfirmationType>,
  ) => void;
}) => {
  const { accountInfo, setConfirmationData } = props;
  const { access = [] } = useAccessControl();
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path}>
        <Workflows
          setConfirmationData={setConfirmationData}
          accountInfo={accountInfo}
        />
      </Route>
      {access.includes('workflow:write') && (
        <Route path={`${path}/create`}>
          <EditWorkflow />
        </Route>
      )}
      <Route path={`${path}/edit/:id`}>
        <EditWorkflow />
      </Route>
    </Switch>
  );
};

export default WorkflowRoutes;
